import PnlPage from "@Quest/Projects/Pages/PnlPage.vue";
import ProjectCapexPage from "@Quest/Projects/Pages/ProjectCapexPage.vue";
import ProjectExpenseAllocationsPage from "@Quest/Projects/Pages/ProjectExpenseAllocationsPage.vue";
import ProjectExpenseSavingsPage from "@Quest/Projects/Pages/ProjectExpenseSavingsPage.vue";
import ProjectMarginsPage from "@Quest/Projects/Pages/ProjectMarginsPage.vue";
import ProjectPage from "@Quest/Projects/Pages/ProjectPage.vue";
import ProjectResourceAllocationsPage from "@Quest/Projects/Pages/ProjectResourceAllocationsPage.vue";
import ProjectResourceCostsPage from "@Quest/Projects/Pages/ProjectResourceCostsPage.vue";
import ProjectResourceSavingsPage from "@Quest/Projects/Pages/ProjectResourceSavingsPage.vue";
import ProjectRevenuesPage from "@Quest/Projects/Pages/ProjectRevenuesPage.vue";
import MyPortfolioProjectsPage from "@Quest/Projects/Pages/MyPortfolioProjectsPage.vue";


export const routes = [
    {
        path: "/q/project/summary/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectPage
    },
    {
        path: "/q/project/revenues/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectRevenuesPage
    },
    {
        path: "/q/project/margins/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectMarginsPage
    },
    {
        path: "/q/project/pnl/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: PnlPage
    },
    {
        path: "/q/project/expense-allocations/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectExpenseAllocationsPage
    },
    {
        path: "/q/project/expense-savings/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectExpenseSavingsPage
    },
    {
        path: "/q/project/resource-allocations/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectResourceAllocationsPage
    },
    {
        path: "/q/project/resource-savings/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectResourceSavingsPage
    },
    {
        path: "/q/project/resource-costs/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectResourceCostsPage
    },
    {
        path: "/q/project/capex/:workspaceId/:tchProjectId/:projectId/:planId?",
        component: ProjectCapexPage
    },

    {
        path: "/my-projects/list/:workspaceId/:tchProjectId",
        component: MyPortfolioProjectsPage
    },
]
